/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from "react"
import type { GatsbyBrowser } from "gatsby"

import { init as initAttributionTracking } from "@helpscout/attributionjs"

import Layout from "./src/components/Layout/Layout"

import OptionalScripts from "./src/components/ThirdPartyScripts/OptionalScripts/OptionalScripts"
import PartnerStackCookies from "./src/components/ThirdPartyScripts/RequiredScripts/PartnerStackCookies/PartnerStackCookies"
import RequiredScripts from "./src/components/ThirdPartyScripts/RequiredScripts/RequiredScripts"

declare global {
  interface Window {
    clearbit: any
    ga: any
    mixpanel: any
    Beacon: any
  }
}

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = () => {
  // Initializes Mixpanel and calls "Viewed Page" event
  initAttributionTracking()
}

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => {
  return (
    <>
      <RequiredScripts />
      <OptionalScripts path={props.location.pathname} />
      <Layout
        path={props.location.pathname}
        template={props.pageContext.template as string}
        useStaticHeader={!!props.pageContext.useStaticHeader}
      >
        {element}
      </Layout>
    </>
  )
}
